import cookies from 'js-cookie';

import {undef} from './undef';
import {hasValidDates} from './dates';

const STATE_COOKIE_NAME = 'ha-state-prst';
const TRIP_COOKIE_NAME = 'ha-trip-prst';

function getStateCookieDestinationValues(stateCookieData) {
    if (stateCookieData) {
        const {
            lbsKeywords
        } = stateCookieData;

        if (lbsKeywords) {
            const destination = lbsKeywords.replace(/\+/g, ' ');

            return {
                destination
            };
        }
    }

    return {};
}

function getTripCookieDatesValues(tripCookieData) {
    if (tripCookieData) {
        const {
            arrival: startDate,
            departure: endDate
        } = tripCookieData;

        if (hasValidDates(startDate, endDate)) {
            return {
                startDate,
                endDate
            };
        }
    }

    return {};
}

// eslint-disable-next-line complexity
function getTripCookieGuestsValues(tripCookieData) {
    if (tripCookieData) {
        let {
            numberOfAdults,
            numberOfChildren,
            numberOfBedrooms,
            petIncluded
        } = tripCookieData;

        numberOfAdults = parseInt(numberOfAdults, 10);
        numberOfAdults = !isNaN(numberOfAdults) ? numberOfAdults : undef;

        if (numberOfAdults === 0 || numberOfAdults === undef) {
            return {};
        }

        numberOfChildren = parseInt(numberOfChildren, 10);
        numberOfChildren = !isNaN(numberOfChildren) ? numberOfChildren : undef;

        numberOfBedrooms = parseInt(numberOfBedrooms, 10);
        numberOfBedrooms = !isNaN(numberOfBedrooms) ? numberOfBedrooms : undef;

        petIncluded = (typeof petIncluded === 'string') ? petIncluded === 'true' : petIncluded;

        return {
            adultsCount: numberOfAdults,
            childrenCount: numberOfChildren,
            bedroomsCount: numberOfBedrooms,
            petIncluded
        };
    }

    return {};
}

function getSearchCookies() {
    const stateCookieData = cookies.getJSON(STATE_COOKIE_NAME);
    const tripCookieData = cookies.getJSON(TRIP_COOKIE_NAME);

    const destinationValues = getStateCookieDestinationValues(stateCookieData);
    const datesValues = getTripCookieDatesValues(tripCookieData);
    const guestsValues = getTripCookieGuestsValues(tripCookieData);

    return {
        destinationValues,
        datesValues,
        guestsValues
    };
}

function removeCookieKeys(name, keys) {
    const data = cookies.getJSON(name);

    if (data) {
        for (const key of keys) {
            delete data[key];
        }

        cookies.set(name, data);
    }
}

function removeTripCookieDates() {
    removeCookieKeys(TRIP_COOKIE_NAME, ['arrival', 'departure']);
}

export {
    STATE_COOKIE_NAME,
    TRIP_COOKIE_NAME,
    getSearchCookies,
    removeTripCookieDates
};
